import React from 'react'

export type ApplicationEntryValue =
  | React.JSX.Element
  | string
  | undefined
  | null

type ApplicationEntryProps = {
  title: string
  value: ApplicationEntryValue
}

const ApplicationEntry = ({ title, value }: ApplicationEntryProps) => {
  if (value === undefined || value === null) {
    return <></>
  }

  return (
    <div className="tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-4">
      <p className="tw-text-stone-400 tw-text-sm">{title}</p>
      {typeof value === 'string' ? (
        <p className="tw-text-sm tw-font-medium tw-text-zinc-900">{value}</p>
      ) : (
        value
      )}
    </div>
  )
}

export default ApplicationEntry
